// extracted by mini-css-extract-plugin
export default {"button-list":"ButtonSettingsForm_button-list__5IZAb","form-button":"ButtonSettingsForm_form-button__0NvsZ","two-input-row":"ButtonSettingsForm_two-input-row__15s0n"};